import { useMemo } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { listEventTypes } from 'services/Calender/calendarServices';
import { totalCountEvent } from 'services/generalServices';
import { queryKeys } from 'hooks/config/queryClient';

export default function useGetEventTypes(practiceAreaId = []) {
  const queryClient = useQueryClient();

  const normalizedPracticeAreaId = useMemo(() => (Array.isArray(practiceAreaId) ? practiceAreaId : []), [practiceAreaId]);

  const { data: typeList = [], isLoading: isEventTypeLoading } = useQuery({
    queryKey: queryKeys.eventTypes.list(normalizedPracticeAreaId),
    queryFn: async () => {
      const countResponse = await totalCountEvent('event-type');
      const obj = {
        pageLimit: countResponse.data,
        pagination_token: '',
        pagination_direction: '',
        practiceAreaId: normalizedPracticeAreaId,
      };
      const res = await listEventTypes(obj);
      const data = res?.data['event-type'] || [];
      return data.map((item) => ({
        event_type: item.event_type,
        event_type_icon: item.event_type_icon,
        event_type_id: item.event_type_id,
      }));
    },
    refetchOnWindowFocus: false,
  });

  const getEventTypes = (nextPracticeAreaId = []) => {
    queryClient.invalidateQueries({ queryKey: queryKeys.eventTypes.list(nextPracticeAreaId) });
  };

  return {
    getEventTypes,
    typeList,
    isEventTypeLoading,
  };
}
